import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/Accordion/accordion';
import AngleRightIcon from '@patternfly/react-icons/dist/js/icons/angle-right-icon';
import { AccordionContext } from './AccordionContext';
export var AccordionToggle = function AccordionToggle(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      id = _a.id,
      _a$isExpanded = _a.isExpanded,
      isExpanded = _a$isExpanded === void 0 ? false : _a$isExpanded,
      _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      component = _a.component,
      props = __rest(_a, ["className", "id", "isExpanded", "children", "component"]);

  return React.createElement(AccordionContext.Consumer, null, function (_ref) {
    var ToggleContainer = _ref.ToggleContainer;
    var Container = component || ToggleContainer;
    return React.createElement(Container, null, React.createElement("button", Object.assign({
      id: id,
      className: css(styles.accordionToggle, isExpanded && styles.modifiers.expanded, className)
    }, props, {
      "aria-expanded": isExpanded
    }), React.createElement("span", {
      className: css(styles.accordionToggleText)
    }, children), React.createElement("span", {
      className: css(styles.accordionToggleIcon)
    }, React.createElement(AngleRightIcon, null))));
  });
};